<div class="flex h-screen w-screen overflow-hidden relative flex-nowrap">
    <div class="bg-sky-500 h-full flex-[7] flex-1">
        <img src="login-screen-background.png" alt="Login Screen Background" class="w-full h-full object-cover">
    </div>
    <div class="bg-primary-500 h-full flex flex-[4] flex-col items-center justify-center">
        <div class="flex flex-col items-center justify-center gap-8">
            <img src="assets/beta80-vertical-logo-white.svg" alt="Beta80 Group" class="w-[18.75rem]">
            <h1 class="text-white text-6xl font-bold">{{ appName() }}</h1>
            <p class="text-white text-sm">© 2025-{{ appYear() }}. <span>{{ 'APP.RIGHTS' | translate }}</span></p>
        </div>
    </div>
    <div class="bg-white absolute z-10 left-[50%] top-[50%] -translate-x-1/2 -translate-y-1/2 max-w-[416px] w-full nexa-density-equal rounded-xl p-6 flex flex-col gap-6">
        <div class="flex items-center justify-between mb-2">
            <h1 class="text-2xl font-bold text-gray-900 m-0">{{ formTitle() }}</h1>
        </div>

        @if (formMessage()) {
            <div class="bg-blue-50 border border-blue-200 text-blue-800 px-4 py-3 rounded-md text-sm" role="alert">
                {{ formMessage() }}
            </div>
        }

        @if (errorMessage()) {
            <div class="bg-red-50 border border-red-200 text-red-800 px-4 py-3 rounded-md text-sm" role="alert">
                {{ errorMessage() }}
            </div>
        }

        @if (successMessage()) {
            <div class="bg-green-50 border border-green-200 text-green-800 px-4 py-3 rounded-md text-sm" role="alert">
                {{ successMessage() }}
            </div>
        }

        @if (isLoading()) {
            <div class="text-center text-gray-600 text-sm" aria-live="polite">{{ 'COMMON.PROCESSING' | translate }}</div>
        }

        @if (isNewPasswordRequired()) {
            <nexa-dynamic-form
                [config]="currentFormConfig()"
                (formSubmit)="handleFormSubmit($event)"
                [disabled]="isLoading()"
            />
            <div class="flex justify-start mt-2">
                <a href="#" class="text-sm text-primary-600 hover:underline" (click)="$event.preventDefault(); toggleRecoveryForm()">
                    {{ 'APP.BACK_TO_LOGIN' | translate }}
                </a>
            </div>
        } @else if (showRecoveryForm()) {
            <nexa-dynamic-form
                [config]="currentFormConfig()"
                (formSubmit)="handleFormSubmit($event)"
                [disabled]="isLoading()"
            />
            <div class="flex justify-between mt-2">
                <a href="#" class="text-sm text-primary-600 hover:underline" (click)="$event.preventDefault(); toggleRecoveryForm()">
                    {{ 'APP.BACK_TO_LOGIN' | translate }}
                </a>
                @if (!codeSent()) {
                    <a href="#" class="text-xs text-gray-500 hover:underline" (click)="$event.preventDefault(); iHaveACode()">
                        {{ 'APP.HAVE_CODE' | translate }}
                    </a>
                }
            </div>
        } @else {
            <nexa-dynamic-form
                [config]="currentFormConfig()"
                (formSubmit)="handleFormSubmit($event)"
                (actionLinkClick)="handleActionLinkClick($event)"
                [disabled]="isLoading()"
            />
        }
    </div>
</div>
